export default {
  common: {
    regionZone: "Région/Zone",
    seller: "Vendeur",
    chillerOrPlant: "Objectif",
    dateRange: "Date range",
    showNumber: "Montrer le numéro",
    hallOfFame: "Hall de la renommée",
    statisticChart: "Graphique statistique",
    win: "Gagner",
    pipeline: "Pipeline",

    chillerAndChillerPlant: "Installation de refroidisseur et de refroidisseur",
    chiller: "refroidisseur",
    chillerPlant: "Installation de refroidisseur",

    ChillerRetrofit: "Rétrofit du groupe froid",
    ChillerPlantRetrofit: "Rétrofit de la centrale froide",
    HeatingElectricRetrofit: "Rénovation de chaudière à pompe à chaleur",

    heating: "Chauffage",

    regions: "Région",
    zones: "Zone",

    resetPipelineCheckMesg:
      "Le système est sur le point de remplacer les données instantanées du mois dernier par les données actuelles du pipeline. Cette opération est irréversible. Êtes-vous sûr de vouloir effectuer cette opération ?",
    resetPipeline: "Réinitialiser Pipeline",
    resetLastMonthPipelinedata: "Réinitialiser les données du pipeline du mois dernier",

    verificationCode: "Code de vérification",
    enterVerificationCode: "Veuillez entrer le code de vérification pour confirmer votre opération",
    verificationCodeError: "Le code de vérification est une erreur",

    note: "Note",
    dataBefore202601:
      "Les données pour janvier 2026 et antérieures proviennent de la version 1.0 et ne prennent actuellement pas en charge les requêtes conditionnelles pour l' 'état du projet' et les 'objectifs du projet'.",
    iKnowThis: "Fermer",
    availableWhen202602: "Disponible à partir de février 2026"
  }
}



// WEBPACK FOOTER //
// ./src/locale/dashboard/fr.js